import React, { useState, useRef, useEffect } from "react";
import AdmissionEnquiryForm from './AdmissionForm'
import AdmissionEnquiryTable from './AdmissionTable'
import {
  Box,
  Divider,
  FormControl,
  FormLabel,
  Input,
  Button,
  VStack,
  Select,
  Grid,
  Flex,
  Icon,
  Text,
  InputGroup,
  InputRightElement,
  useDisclosure,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  List,
  ListItem,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";

import { FaUser, FaUserShield, FaPlus, FaPrint, FaSync } from "react-icons/fa";
import Print_pdf_adm_enq from "./Print_pdf_adm_enq";
import { BASE_URL } from "../../../Globalapi/Globalapi";


const AdmissionEnquiry = () => {

  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef(); // Reference to Print_pdf_class_list component
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchEnquiries = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/admin/admission/list_all_admission.php`
      );
      
      const data = await response.json();
      console.log(data);

      if (data.success) {
        setEnquiries(data.data);
        setIsDataLoaded(true); // Mark data as loaded

        
      } else {
        setError(data.message || "Failed to load enquiries");
      }
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchEnquiries();
  }, []);


  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };
  return (
    
    <div>
         <Box borderRadius="md" mx="auto">
      <div style={{ backgroundColor: "#FBFBFD",  }}>
        <div className="teacher-list-container">
          <div
            className="header"
            style={{ display: "flex", alignItems: "center" }}
          >
            <h1 style={{ fontSize: "20px", margin: 0 }}>Admission Enquiry</h1>
            <div className="action-buttons" style={{ marginLeft: "auto" }}>
              {/* <Button
                className="refresh-button"
                boxShadow="md"
                backgroundColor="white"
                fontSize="11px"
                onClick={() => {
                  console.log("Refresh button clicked");
                }}
              >
                <FaSync color="#515B73" />
                
              </Button> */}
             <Button
              className="export-button"
              display={{ base: "none", md: "flex" }}
              backgroundColor="white"
              fontSize="11px"
              boxShadow="md"
              onClick={handlePrint} // Attach the print handler here
            >
              <FaPrint color="#515B73" />
              Print PDF
            </Button>
              
              <AdmissionEnquiryForm />
            </div>
          </div>

          <Box className="breadcrumb">
            <Link
              to="/admin"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <span>Dashboard</span>
            </Link>{" "}
            / <span>Students</span> / <span>Admission </span>
          </Box>
        </div>
     
      </div>
      {/* <AdmissionEnquiryForm /> */}
      <AdmissionEnquiryTable />
      </Box>

      <div style={{ display: "none" }}>
        <Print_pdf_adm_enq ref={printComponentRef} enquiries={enquiries} />
      </div>
    </div>
  )
}

export default AdmissionEnquiry